module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSlot,
      "code": _vm.ExSlotCode,
      "title": "Custom pagination buttons"
    }
  }, [_c('p', [_vm._v("You can customize the buttons using "), _c('b', [_c('code', [_vm._v("b-pagination-button")])]), _vm._v(" as scoped slot.")]), _vm._v(" "), _c('p', [_vm._v("For example, you can customize the inner text or use "), _c('code', [_vm._v("router-link")]), _vm._v(" as tag.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011dde26"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/pagination/Pagination.vue
// module id = 1462
// module chunks = 37